module.exports = __webpack_public_path__ + "img/educacion.5e8fad6d.svg";